import gsap from "gsap";
import { initLogoGrid } from '../utils/illustrations';
export default function initPreloader(callback) {
  console.log('preload')
  const loaderWrap = document.querySelector('.loader-wrap');
  const wrapper = document.querySelector('#wrapper');
  if(!loaderWrap) return;
  const gridHero = document.getElementById('logo-grid');
  document.body.classList.add('is-loading');
  const bg = loaderWrap.querySelector('#preloader-bg');
  const logo = loaderWrap.querySelector('#preloader-svg');
  const logoHolder = loaderWrap.querySelector('.loader-logo-holder');
  const tl = gsap.timeline({
    onComplete: () => {
      loaderWrap.remove();
    },
  });
  const tlShow = gsap.timeline();
  const desktop = window.matchMedia('(min-width:768px)').matches;
  console.log(desktop)
  const y = desktop? -170 : -70;
  const curve = 'M0 502S175 272 500 272s500 230 500 230V0H0Z';  
  const flat = 'M0 2S175 1 500 1s500 1 500 1V0H0Z';
  const logoShowScene = gsap.to(logo, {opacity: 1, y: 0, delay: 0.3});
  const logoHideScene = gsap.to(logoHolder, {opacity: 0, y ,  delay: 0.3});
  tl.add(logoShowScene);
  tl.add(logoHideScene);

  const wrapperScene = gsap.from(wrapper, {autoAlpha: 0, duration: 0.8, onStart: ()=> {
    document.body.classList.remove('is-loading');
    if(gridHero) {
      initLogoGrid();
      if(callback) callback();
    }
  }});
  tlShow.add(wrapperScene, 0);
  const bgScene1 = gsap.to(bg, {duration: 0.8, attr: { d: curve }, ease: 'power2.easeIn'});
  const bgScene2 = gsap.to(bg, {duration: 0.8, attr: { d: flat }, ease: 'power2.easeOut'});
  const sceneLoaderWrap = gsap.to(loaderWrap, {yPercent: -100 });
  
  tlShow.add(bgScene2, 0);
  tl.add(bgScene1).add(tlShow).add(sceneLoaderWrap);

}